export enum AvailabilityStatus {
    Yes = 'yes',
    Partial = 'partial',
    No = 'no',
}
